import React, { useEffect, useRef, useState } from "react";
import { Wrapper } from "@googlemaps/react-wrapper";
import appConfig from "@appConfig";

const MapInstance = ({ center, pins }) => {
    const ref = useRef(null);
    const [map, setMap] = useState();

    useEffect(() => {
        if (ref.current && !map) {
            setMap(
                new window.google.maps.Map(ref.current, {
                    center,
                    zoom: 14,
                    disableDefaultUI: true,
                    zoomControl: true,
                    mapId: "DEMO_MAP_ID",
                })
            );
        }
    }, [ref, map, center]);

    useEffect(() => {
        if (map && pins) {
            pins.forEach(pin => {
                new window.google.maps.Marker({
                    position: pin.position,
                    map: map,
                    title: pin.title,
                    icon: pin.type === 'os'
                        ? "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
                        : "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
                });
            });

            const bounds = new window.google.maps.LatLngBounds();
            pins.forEach(p => bounds.extend(p.position));
            map.fitBounds(bounds);
        }
    }, [map, pins]);

    return <div ref={ref} style={{ width: "100%", height: "200px", borderRadius: "8px" }} />;
};

const MiniMap = ({ data }) => {
    const GMAPS_API_KEY = appConfig.mapsKey;

    const pins = [
        {
            type: 'os',
            title: 'Localização da OS',
            position: {
                lat: data.latitude_os ? parseFloat(data.latitude_os.replace(",", ".")) : parseFloat(data?.latitude_os),
                lng: data.longitude_os ? parseFloat(data.longitude_os.replace(",", ".")) : parseFloat(data?.longitude_os),
            }
        },
        {
            type: 'fechamento',
            title: 'Localização do Fechamento',
            position: {
                lat: data.latitude_fechamento,
                lng: data.longitude_fechamento
            }
        }
    ];

    const center = pins[0].position;

    return (
        <Wrapper apiKey={GMAPS_API_KEY}>
            <MapInstance center={center} pins={pins} />
        </Wrapper>
    );
};

export default MiniMap;
